import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Pressable, StyleSheet, Text, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import theme from 'shared/styles/theme';
import { VaroFontNames } from 'shared/styles/typography';

export interface AmountSectionProps {
  amountText?: string;
  onAddIconClick?: () => void;
  isAmountStale?: boolean;
  disabled?: boolean;
}

const AmountSection = ({
  amountText,
  onAddIconClick,
  isAmountStale,
  disabled,
}: AmountSectionProps) => {
  if (!amountText && !onAddIconClick) {
    return null;
  }

  return (
    <View style={styles.amountSection}>
      {amountText ? (
        <Text
          style={[
            styles.amountText,
            isAmountStale && styles.amountStale,
            disabled && interactiveStyles.textDisable,
          ]}
        >
          {/* //TODO: JT-114049 - Add counting Up Animation to render Amount */}
          {amountText}
        </Text>
      ) : null}
      {onAddIconClick ? (
        <Pressable
          style={styles.addIconWrapper}
          onPress={(event) => {
            event.stopPropagation();
            onAddIconClick();
          }}
        >
          <Icon
            iconKey="ADD"
            iconSize="SM"
            iconColor={theme.color.interactive.primary}
          />
        </Pressable>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  addIconWrapper: {
    alignItems: 'center',
    backgroundColor: theme.color.background.tertiary,
    borderRadius: 30,
    height: 24,
    justifyContent: 'center',
    padding: 6,
    width: 24,
  },
  amountSection: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing.s,
    justifyContent: 'flex-end',
  },
  amountStale: {
    color: theme.color.text.muted,
  },
  amountText: {
    color: theme.color.text.primary,
    fontFamily: VaroFontNames.National2Compressed,
    fontSize: 28,
    textAlign: 'right',
    textTransform: 'uppercase',
  },
});

const interactiveStyles = StyleSheet.create({
  textDisable: {
    color: theme.color.text.muted,
  },
});

export default AmountSection;
